<template>
  <section class="components-forum-feed-topics-forum mb-4">
    <div class="container py-3">
      <router-link :to="{ name: 'forum-topic', params: { id: topic.id } }">
        <div class="row">
          <div class="col-1">
            <div class="d-flex justify-content-center">
              <img
                :src="topic.author_image"
                alt="pic-user"
                class="picture-user"
              />
            </div>
          </div>
          <div class="col-11">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <small class="mr-2 mb-0">Postado por</small>
                <p class="mb-0">
                  <strong>{{ topic.author_name }}</strong>
                </p>
              </div>
              <small>
                {{ dateTopic }}
              </small>
            </div>
            <div class="pt-4">
              <h5 class="text-uppercase">
                {{ topic.title }}
              </h5>
              <div v-html="topic.content"></div>
            </div>
            <div class="d-flex">
              <p class="mr-1">
                <strong>Tags: </strong>
              </p>
              <p
                v-for="(tag, index) in topic.tags"
                :key="index"
                class="mr-1 text-lowercase"
              >
                #{{ tag }}
              </p>
            </div>
            <div class="d-flex align-item-center pb-2">
              <i
                class="text-white"
                :class="`${icon_map[topic.category]} mr-2`"
              ></i>
              <small> {{ topic.category_name }}</small>
            </div>
          </div>
        </div>
      </router-link>
      <div class="row justify-content-end mt-2">
        <div class="col-11">
          <div class="d-flex align-item-center border-top py-1">
            <button
              class="curtida mr-3 d-flex align-items-center"
              @click="like"
            >
              <i
                :class="
                  `icon-like mr-1 ${
                    isLiked ? 'text-success' : 'text-secondary'
                  }`
                "
              />
              <small class="num-likes mx-1"
                >{{ topic.num_likes }} curtidas</small
              >
            </button>

            <router-link
              :to="{ name: 'forum-topic', params: { id: topic.id } }"
              class="align-items-center"
              :class="{
                'd-flex': !$route.name.includes('forum-topic'),
                'd-none': $route.name.includes('forum-topic')
              }"
            >
              <button
                class="btn-interact text-secondary d-flex align-items-center"
              >
                <i class="icon-comments mr-1 text-secondary" />
                <small>Responder</small>
              </button>
            </router-link>

            <b-dropdown
              variant="link"
              class="mt-n2"
              toggle-class="text-decoration-none"
              right
            >
              <template #button-content>
                <span class="text-secondary">...</span>
              </template>
              <b-dropdown-item
                @click="editDialog = true"
                v-if="showOptionsTopic"
                class="px-3"
              >
                <i class="icon-carbon_edit mr-2"></i> Editar
              </b-dropdown-item>
              <b-modal
                id="modal-new-topic"
                v-model="editDialog"
                size="lg"
                centered
                hide-footer
                hide-header
              >
                <modal-edit-topic
                  :id="topic.id"
                  :options="categories"
                  :title="topic.title"
                  :tags="topic.tags"
                  :content="topic.content"
                  :category="topic.category"
                  @close-modal="editDialog = false"
                />
              </b-modal>
              <b-dropdown-item
                v-if="!showOptionsTopic"
                @click="denounceDialog = true"
                class="px-3"
              >
                <i class="icon-alert mr-2"></i>Denúnciar
              </b-dropdown-item>
              <b-modal
                id="modal-denounce"
                v-model="denounceDialog"
                size="md"
                centered
                hide-footer
                hide-header
              >
                <modal-denounce
                  @close-modal="denounceDialog = false"
                  :topic="topic"
                />
              </b-modal>
              <b-dropdown-item
                @click="removeTopic = true"
                v-if="showOptionsTopic"
                class="px-3"
              >
                <i class="icon-x mr-2"></i> Excluir
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <confirmation
      v-model="removeTopic"
      @confirm="deletePost"
      text="Tem certeza que deseja exluir seu tópico?"
      confirm-button-text="Excluir"
    />
  </section>
</template>

<script>
import { formatDate } from "@/functions/helpers.js";
import ModalEditTopic from "./ModalEditTopic.vue";
import { mapState } from "vuex";
import ModalDenounce from "./ModalDenounce.vue";

export default {
  components: { ModalEditTopic, ModalDenounce },
  name: "TopicsForum",
  data() {
    return {
      denounceDialog: false,
      answering: false,
      removeTopic: false,
      editDialog: false
    };
  },
  props: {
    topic: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("forum", ["categories"]),
    icon_map() {
      return {
        1: "icon-file-music",
        2: "icon-mic",
        3: "icon-amplifier",
        4: "icon-violin",
        5: "icon-piano-keys-light",
        6: "icon-guitar-electric",
        7: "icon-guitar",
        8: "icon-guitar-acoustic",
        9: "icon-drums"
      };
    },
    isAnotherUser() {
      return this.comment?.user_id != this.$user?.user?.id;
    },
    isLiked() {
      return this.topic.likes?.find(user => user == this.$user?.user?.id);
    },
    showOptionsTopic() {
      return this.$user?.user?.id == this.topic.user;
    },
    dateTopic() {
      return formatDate(this.topic.created_at);
    }
  },
  methods: {
    like() {
      this.$store.dispatch("forum/likedTopic", this.topic.id).then(() => {
        this.$emit("refresh");
      });
    },
    deletePost() {
      this.$store
        .dispatch("forum/deleteTopic", this.topic.id)
        .then(() => {
          this.$emit("refresh");
          this.$message.success("Tópico excluido com sucesso.");
        })
        .catch(() => {
          this.$message.error("Não foi possível excluir seu tópico.");
        })
        .finally(() => {
          this.$emit("close-modal");
          if (this.$route.name == "forum-topic") {
            this.$router.push({ name: "forum-feed" });
          }
        });
    }
  }
};
</script>

<style lang="scss">
.components-forum-feed-topics-forum {
  background: #111112;
  border-radius: 8px;
  color: #ffffff;
  text-align: left;
  border: none;

  a {
    color: #fff;
    transition: 0.4s;
    &:hover {
      text-decoration: none;
      filter: brightness(70%);
    }
  }

  .container {
    max-width: 95%;
  }

  .num-likes {
    color: #8b8b8b;
  }

  .curtida,
  .btn-interact {
    background: none;
    border: none;
    transition: 0.4s;

    &:hover {
      filter: brightness(70%);
    }
  }

  .picture-user {
    border-radius: 50%;
    width: 40px;
    aspect-ratio: 1/1;
  }

  .border-top {
    border-top: #2c2c2c 1px solid !important;
  }

  .dropdown-toggle {
    color: white;
    padding: 0;
    font-size: 24px;

    &::after {
      display: none;
    }
  }

  .dropdown-item {
    color: #fff !important;
    &:hover {
      background-color: #020204 !important;
      color: #fff;
    }
  }

  .dropdown-menu {
    position: relative;
    background-color: #020204 !important;

    &:before {
      content: " ";
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid #020204;

      position: absolute;
      right: 10%;
      top: -15%;
    }
  }
}
</style>
